import React, { useState } from 'react';
import axios from 'axios'; // Import axios

// Define the API base URL (same as MarkerForm.js)
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || 'https://comtruaduytan.com/api/markers/';

const InstagramPostForm = ({ lat, lon }) => { // Accept lat and lon as props
  const [caption, setCaption] = useState('');
  const [tags, setTags] = useState('');
  const [locationName, setLocationName] = useState('');
  const [media, setMedia] = useState(null); // State for the single media file
  const [error, setError] = useState(null); // State for error handling

  // Helper function to upload a single media file
  const uploadMediaFile = async () => {
    if (!media) return null; // Return null if no file is selected

    const formData = new FormData();
    formData.append('files', media); // Use 'files' as the key, like in MarkerForm

    try {
      const response = await axios.post(`${apiBaseUrl}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      // Assuming the API returns an object with a 'results' array containing media info
      // And we only uploaded one file, so we take the first result.
      return response.data.results && response.data.results.length > 0 ? response.data.results[0] : null;
    } catch (uploadError) {
      console.error('Error uploading file:', uploadError.response?.data || uploadError.message);
      throw new Error('Error uploading file'); // Re-throw to be caught by handleSubmit
    }
  };


  const handleSubmit = async (e) => { // Make handleSubmit async
    e.preventDefault();
    setError(null); // Reset error state

    try {
      // 1. Upload media file if it exists
      let uploadedMediaInfo = null;
      if (media) {
        uploadedMediaInfo = await uploadMediaFile();
      }

      // 2. Retrieve auth token
      const token = localStorage.getItem('token');
      if (!token) {
        throw new Error("Authentication token not found. Please log in.");
      }

      // 3. Construct the payload, mapping Instagram fields to Marker fields
      // Using hardcoded IDs from MarkerForm's initial state for consistency
      const payload = {
        title: caption || "Instagram Post", // Use caption as title, provide default
        description: `Tags: ${tags || 'N/A'}\\nLocation Name: ${locationName || 'N/A'}`, // Combine tags and location name in description
        location: { // (25.0000, 0.0000) – Deep in the Sahara.
          type: 'Point',
          coordinates: [parseFloat(lon), parseFloat(lat)], // Use passed coordinates (lon, lat order for GeoJSON)
        },
        userId: '671e566bf1105a8a7070e048', // Hardcoded from MarkerForm
        mapId: '671e566bf1105a8a7070e048', // Hardcoded from MarkerForm
        contributor: '671e566bf1105a8a7070e048', // Hardcoded from MarkerForm
        media: uploadedMediaInfo ? [uploadedMediaInfo] : [], // Use uploaded media info if available
        sharedWith: ["671e566bf1105a8a7070e048"], // Hardcoded from MarkerForm
        status: 'public', // Default status
      };

      console.log('Submitting Instagram Post payload:', payload); // Log the payload

      // 4. Send the request to the marker endpoint
      await axios.post(apiBaseUrl, payload, {
        headers: {
          Authorization: `Bearer ${token}`, // Include token
        },
      });

      // 5. Handle success - Reset form fields
      alert('Instagram post created successfully!'); // Simple success message
      setCaption('');
      setTags('');
      setLocationName('');
      setMedia(null);
      // Clear the file input visually (may need a more robust solution depending on browser)
      const fileInput = document.getElementById('media');
      if (fileInput) {
        fileInput.value = '';
      }

    } catch (submitError) {
      console.error('Error submitting Instagram post:', submitError.response?.data || submitError.message);
      setError(`Error creating post: ${submitError.response?.data?.message || submitError.message}`);
    }
  };

  const handleMediaChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setMedia(e.target.files[0]); // Store the selected file object
    } else {
      setMedia(null);
    }
  };

  // Basic styling (can be improved)
  const inputStyle = { display: 'block', width: '95%', marginBottom: '10px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', fontFamily: "'Nunito', sans-serif" };
  const labelStyle = { display: 'block', marginBottom: '5px', fontWeight: 'bold', fontFamily: "'Nunito', sans-serif" };
  const buttonStyle = { padding: '10px 15px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', marginTop: '10px', fontFamily: "'Nunito', sans-serif" };
  const errorStyle = { color: 'red', marginTop: '10px', fontWeight: 'bold', fontFamily: "'Nunito', sans-serif" };
  const formContainerStyle = { // New style object for the form container
    padding: '20px',
    maxWidth: '300px', // Consistent max width
    margin: '40px auto', // Center the form
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0 1px 6px rgba(0, 0, 0, 0.15)', // Consistent shadow
    fontFamily: "'Nunito', sans-serif"
  };


  return (
    <div style={formContainerStyle}> {/* Wrap form in a div and apply centering style here */}
      <form onSubmit={handleSubmit}>
        {error && <p style={errorStyle}>{error}</p>} {/* Display error message */}
        <div>
          <label htmlFor="caption" style={labelStyle}>Caption:</label>
          <textarea
            id="caption"
            value={caption}
            onChange={(e) => setCaption(e.target.value)}
            style={{ fontFamily: "'Nunito', sans-serif", width: 'calc(100% - 20px)', padding: '15px', marginTop: '10px', border: '1px solid #ddd', borderRadius: '6px', boxSizing: 'border-box', resize: 'vertical', fontSize: '12px', minHeight: '120px' }}
          />
          {/* Keep existing inline style for textarea */}
        </div>
        <div>
          <label htmlFor="tags" style={labelStyle}>Tags:</label>
          <input
            type="text"
            id="tags"
            value={tags}
            onChange={(e) => setTags(e.target.value)}
            style={inputStyle}
          />
        </div>
        <div>
          <label htmlFor="locationName" style={labelStyle}>Location Name:</label>
          <input
            type="text"
            id="locationName"
            value={locationName}
            onChange={(e) => setLocationName(e.target.value)}
            style={inputStyle}
          />
        </div>
        <div>
          <label htmlFor="media" style={labelStyle}>Media:</label>
          <input
            type="file"
            id="media"
            onChange={handleMediaChange}
            style={inputStyle}
            accept="image/*,video/*" // Accept images and videos
          />
        </div>
        <button type="submit" style={buttonStyle}>Create Post</button>
      </form>
    </div>
  );
};

export default InstagramPostForm;
